import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Intro } from './components/Intro';
import { Pillars } from './components/Pillars';
import { MethodTimeline } from './components/MethodTimeline';
import { WhatsInside } from './components/WhatsInside';
import { Bonuses } from './components/Bonuses';
import { RecipeTeaser } from './components/RecipeTeaser';
import { Mindset } from './components/Mindset';
import { ResultsSection } from './components/ResultsSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { PurchaseNotifications } from './components/PurchaseNotifications';
export function App() {
  return <div className="min-h-screen bg-white font-sans text-stone-900 selection:bg-brand-200 selection:text-brand-900" data-id="element-0">
      <Header data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <Intro data-id="element-4" />
        <ResultsSection data-id="element-5" />
        <Pillars data-id="element-6" />
        <MethodTimeline data-id="element-7" />
        <WhatsInside data-id="element-8" />
        <Bonuses data-id="element-9" />
        <RecipeTeaser data-id="element-10" />
        <Mindset data-id="element-11" />
        <FinalCTA data-id="element-12" />
      </main>
      <Footer data-id="element-13" />
      <PurchaseNotifications data-id="element-14" />
    </div>;
}